<template>
	<fragment>
		<common-header
			subname="상담관리"
			name="상담글 작성"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
		></common-header>

		<section ref="container" class="container">
			<nav class="side-nav"></nav>

			<div class="container-fiuld class-making-box clearfix">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						상담설문 쓰기
					</div>
				</div>
				<div class="input-group full-width">
					<table cellpadding="0" cellspacing="0" border="0" width="100%">
						<tr v-for="(item,idx) in survey.surveyItemMappingList" :key="'counsel-survey-for-write-'+survey.surveyId+'-'+idx">
							<td width="200" style="padding-left:20px"><b>{{item.itemName}}</b></td>
							<td v-if="item.type=='주관식'">
								<input class="form-control round m-b-0" type="text" style="text-align:left;" ref="counselAnswer" :surveyItemId="item.surveyItemId" surveyType="주관식">
							</td>
							<td v-if="item.type=='객관식'">
								<select class="form-control round m-b-0" ref="counselAnswer" :surveyItemId="item.surveyItemId" surveyType="객관식">
									<option value=''>{{item.itemName}} 선택</option>
									<option v-for="(childItem,childIdx) in item.child" :key="'counsel-survey-for-write-'+survey.surveyId+'-child-'+childItem.surveyItemId+'-'+childIdx" :value="childItem.surveyItemId">
										{{childItem.itemName}}
									</option>
								</select>
							</td>
						</tr>
					</table>
				</div>


				<br><br><br>
				<div class="title-box m-b-30 m-t-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						상담글 본문쓰기
					</div>
				</div>
				<div class="input-group full-width m-b-5">
					<span class="input-group-addon">
						<input class="form-control round m-b-0" type="text" placeholder="제목을 입력하세요." v-model="title">
					</span>
				</div>
				<div class="input-group full-width">
					<!-- <span class="input-group-addon w160 p-r-5">
						<select class="form-control round m-b-0" v-model="articleCategoryId">
							<option value="0">분류 선택 안함</option>
							<option v-for="category in articleCategoryList"
								:key="`option-category-${hash(category)}`" :value="category.articleCategoryId">
								{{category.name}}
							</option>
						</select>
					</span> -->
					<span class="input-group-addon p-r-5">
						<input class="form-control round m-b-0" type="text" placeholder="작성자" v-model="name">
					</span>
					<span class="input-group-addon p-r-5">
						<input class="form-control round m-b-0" type="text" placeholder="작성자 전화번호" v-model="mobileNum">
					</span>
					<span class="input-group-addon">
						<input class="form-control round m-b-0" type="text" placeholder="비밀번호" v-model="password">
					</span>
				</div>

				<!-- <div class="input-group full-width m-t-10">
					<span class="input-group-addon bg-white on-border round v-mid text-left p-5">
						<span class="text-darkgray" v-for="(fileName, idx) in articleFileNames" :key="`article-file-${fileName}`">
							{{fileName}}<a @click="articleFileMappingList.splice(idx, 1); articleFileNames.splice(idx, 1)" class="f-16 m-l-5 m-r-10 text-blue text-bold">×</a>
						</span>
					</span>
					<span class="input-group-addon w40 v-mid p-l-5">
						<input id="file" type="file" style="display: none;" ref="fileRef" @change="fileUpload">
						<label for="file" class="btn btn-darkgray f-14 round full-width">+</label>
					</span>
				</div> -->
				<div class="input-group full-width m-t-10 bg-white">
					<textarea class="full-width editorContentArticle" cols="30" rows="4" v-model="content">></textarea>
				</div>
				<span class="text-bold">
					<input class="round m-r-5" id="invdlInfoAreeEnable" type="checkbox" value="1" v-model="invdlInfoAreeEnable">
					<span class="text-red">*</span> 개인정보정책에 동의합니다.
				</span>
				<button class="btn btn-blue round m-t-30 m-b-30 pull-right" type="button" @click="putArticle">완료하기</button>
				<button class="btn btn-red round m-t-30 m-b-30 m-r-5 pull-right" type="button" @click="$router.push('/counsel/'+$route.params.boardId)">취소</button>
			</div>

		</section>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;"></modal-alert>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명
	name: 'ViewBoardWrite',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		CommonHeader,
		CommonFooter,
		ModalAlert
	},
	mounted: function() {
		this.initBoard();
	},
	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'상담글 목록',link:"/counsel",selected:true},
				{name:"상담통계", link:"/counselStatistics",selected:false}
			],
			buttons : [
			],
			sideButtons: [],
			sideMenus: [],
			modals: {
				//ModalOnlineClass: ModalOnlineClass.default()
				//ModalOnlineClass.
				ModalAlert: ModalAlert.default()
			},

			articleCategoryList: [],
			articleCategoryId: 0,
			articleFileNames: [],
			articleFileMappingList: [],
			survey: {},
			surveyItemApplList: [],
			name: "",
			mobileNum: "",
			title: "",
			content: "",
			password: "",
			invdlInfoAreeEnable: 0,
			reply: {articleId:0, articleFileNames:[], articleFileMappingList:[], parentsId:0, title:"", content:""},
			editorContentArticle: null,
			editorContentReply: null
		}
	},
	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		checkSetItem() {
			const { name, mobileNum, title, content, password, invdlInfoAreeEnable } = this;
			if(!title){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '제목을 입력하세요.';
				return false;
			}
			if(!name){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '작성자를 입력하세요.';
				return false;
			}
			if(!mobileNum){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '작성자 전화번호를 입력하세요.';
				return false;
			}
			if(!password){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '비밀번호를 입력하세요.';
				return false;
			}
			if(!content){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '본문을 입력하세요.';
				return false;
			}
			if(!invdlInfoAreeEnable){
				this.modals.ModalAlert.show = true;
				this.modals.ModalAlert.msg = '개인정보정책에 동의하세요.';
				return false;
			}
			return true;
		},
		initEditor: function() {
			let that = this;
			window.tinymce.init({
				selector: '.editorContentArticle',
				height: 500,
				branding: false,
				plugins: [
					"autoresize",
					"advlist autolink lists link image charmap print preview anchor",
					"searchreplace visualblocks code fullscreen",
					"insertdatetime media table paste imagetools wordcount lineheight addfile"
				],
				content_style: "body {margin: 40px 2rem !important; line-height: 1.5; width:866px;} body > p {margin: 0}",
				toolbar_mode: 'wrap',
				toolbar: "| insertfile undo redo | styleselect fontselect fontsizeselect lineheight| bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image addfile",
				fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 30pt 32pt 34pt 36pt 38pt 40pt",
				lineheight_formats: "1 1.5 2 2.5 3 3.5 4 4.5 5",
				images_upload_handler: function(blobInfo, success) {
					const formData = new FormData();
					formData.append('file', blobInfo.blob(), blobInfo.filename());
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				files_upload_handler: function(fileObj, success) {
					const formData = new FormData();
					formData.append('file', fileObj);
					Axios.post(`${server.addr()}${server.api.FILE}`, formData).then((response) => {
						success("/download/" + response.data);
					});
				},
				setup: function(editor) {
					editor.on('init', function() {
						editor.setContent(that.content);
					});
					editor.on("change", function() {
						that.content = editor.getContent();
					})
				}
			}).then((r) => {this.editorContentArticle = r[0]});
		},
		initBoard: function() {
			Axios.post(server.addr()+server.api.SURVEY+"/"+server.counselSurveyId).then((response) => {
				this.survey = response.data.return;
			});
			Axios.post(server.addr()+server.api.BOARD+"/"+server.counselBoardId).then((response) => {
				this.articleCategoryList = response.data.return.articleCategoryList;
			}).then(() => {
				this.initEditor();
			});

		},
		fileUpload: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRef.files[0]);

			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData);

				this.articleFileNames.push(this.$refs.fileRef.files[0].name);
				this.articleFileMappingList.push({atchFileId:data});
			} catch(e) {
				//TODO: error exception
			}
		},
		fileUploadReply: async function() {
			const formData = new FormData();
			formData.append("file", this.$refs.fileRefReply.files[0]);
			try {
				const { data } = await Axios.post(`${server.addr()}${server.api.FILE}`, formData);
				this.reply.articleFileNames.push(this.$refs.fileRefReply.files[0].name);
				this.reply.articleFileMappingList.push({atchFileId:data});
			} catch(e) {
				//TODO: error exception
			}
		},
		putArticle: function() {
			if(!this.checkSetItem()) return false;
			// const { articleCategoryId, articleFileMappingList, name, mobileNum, title, content, parentsId, password } = this;
			let { name, mobileNum, title, content, parentsId, password, invdlInfoAreeEnable } = this;
			const boardId = server.counselBoardId;
			let surveyAppl = {};
			if(server.counselSurveyId) {
				surveyAppl =  { surveyId: server.counselSurveyId, mberName: name, mobileNum, surveyItemApplList: [] };
				this.$refs.counselAnswer.forEach(answer => {
					if(answer.getAttribute("surveyType")==="주관식" && answer.value)
						surveyAppl.surveyItemApplList.push({surveyItemId:answer.getAttribute("surveyItemId"), etcText:answer.value});
					else if(answer.value)
						surveyAppl.surveyItemApplList.push({surveyItemId:answer.value});
				});
				if(!surveyAppl.surveyItemApplList.length) surveyAppl = null;
			}
			invdlInfoAreeEnable = this.invdlInfoAreeEnable && 1 || 0;
			// const token = Axios.defaults.headers.common['Authorization'];
			// delete Axios.defaults.headers.common['Authorization'];
			// Axios.put(`${server.addr()}/u${server.api.ARTICLE}`, [{
			Axios.put(`${server.addr()}${server.api.ARTICLE}`, [{
				// articleCategoryId, articleFileMappingList, name, title, content, password, parentsId, boardId, surveyAppl
				name, title, content, password, parentsId, boardId, invdlInfoAreeEnable, surveyAppl
			}]).then(() => {
				// Axios.defaults.headers.common['Authorization'] =token;
				this.$router.push("/counsel/" + boardId);
			});
		}
	}
}
</script>
<style scope>
	tr {height: 50px;}

	.recycle {
		fill: #fff;
		fill-rule: evenodd;
	}

	.btn-group .btn:hover .recycle {
		fill: #fff;
		fill-rule: evenodd;
	}
</style>